import _ from 'lodash'
import Routine from '@/models/Routine'

const GOOD_JOB_TITLES = ['Good job!', 'Wonderful!', 'Excellent!', 'That’s the way!', 'Congratulations!', 'That’s coming along nicely!', 'Sensational!']

export default class Notifier {
  constructor (notify, isMobile) {
    this.notify = notify
    this.isMobile = isMobile
  }

  sendNotification ({title, text, color, time, icon}) {
    const position = this.isMobile ? 'bottom-right' : 'bottom-center'
    this.notify({
      title, text, color, time, icon, position, iconPack: 'feather'
    })
  }

  allTodayTasksCompleted () {
    this.sendNotification({
      title: _.sample(GOOD_JOB_TITLES),
      text: 'You have completed all your tasks for today',
      color: 'dark',
      time: 4000,
      icon:'icon-check'})
  }

  firstTodayTasksCompleted () {
    this.sendNotification({
      title: _.sample(GOOD_JOB_TITLES),
      text: 'Keep up the great work!',
      color: 'dark',
      time: 4000,
      icon:'icon-check'})
  }

  routineFinished (routine) {
    // const routineEnitity = new Routine(routine)
    this.sendNotification({
      title: 'Congratulations! 👏',
      // text: `You have done this routine ${routineEnitity.datesDoneCount()} times in ${routineEnitity.existsForDays()} days, good job!`,
      text: 'Accomplished routines will be glorified at the journey page.',
      color: 'dark',
      time: 10000,
      icon:'icon-award'})
  }

  alreadyDone (icon, title) {
    // const routineEnitity = new Routine(routine)
    this.sendNotification({
      title: 'Congratulations 👏',
      // text: `You have done this routine ${routineEnitity.datesDoneCount()} times in ${routineEnitity.existsForDays()} days, good job!`,
      text: `<b>${title}</b> is already finished!`,
      color: 'dark',
      time: 8000,
      icon: icon})
  }

  completedRoutine (store) {
    this.firstTimeNotification(
      store,
      'completedRoutine',
      'Your first strike, good job!',
      'Did you enjoy it? Is it a well-set routine? You can repeat this routine tomorrow to continue your streak.',
      'icon-battery-charging')
  }

  completedGoal (store) {
    this.firstTimeNotification(
      store,
      'completedGoal',
      'Did you just completed your first goal?!',
      'Absolutely amazing work! This goal will be immortalized on your timeline to remind you of this achievement.',
      'icon-award')
  }

  visitKnowledgePage (store) {
    this.firstTimeNotification(
      store,
      'visitKnowledgePage',
      'This is your knowledge page',
      'Here you will learn practical and valuable information, proven tips and advices everyday.',
      'icon-book')
  }

  visitJourneyPage (store) {
    this.firstTimeNotification(
      store,
      'visitJourneyPage',
      'Welcome to your Journey page',
      'Here you can get insights on your progress and keep a powerful reflection journal.',
      'icon-trending-up')
  }

  rated (store) {
    this.firstTimeNotification(
      store,
      'rated',
      'Thank you for the rating!',
      'Your rating is important to us, it lets us know what you liked and what we could improve.',
      'icon-bell')
  }

  journalAdded (store) {
    this.firstTimeNotification(
      store,
      'journalAdded',
      'First journal entry, yay!',
      'What can\'t be measured can\'t be improved. And that\'s what this journal is about to change, self-knowledge begins now.',
      'icon-book')
  }

  futureTaskAdded (store) {
    this.firstTimeNotification(
      store,
      'futureTaskAdded',
      'You are a planner!',
      'You have just planned an event for the future. By planning, you are preparing the ground for your future self, also you no longer have to think about it.',
      'icon-compass')
  }

  openTodayTab (store) {
    this.firstTimeNotification(
      store,
      'openTodayTab',
      'Focus yourself!',
      'It\'s not just about planning, it\'s about doing something today! That\'s why in \"Today\" you only have what you have planned for today.',
      'icon-activity')
  }

  openNext7DaysTab (store) {
    this.firstTimeNotification(
      store,
      'openNext7DaysTab',
      'Plan your upcoming days',
      'Tasks must be doable and have a deadline. Only then will you find the time to do something about them.',
      'icon-map')
  }

  firstTimeNotification (store, name, title, text, icon) {
    if (!store.getters.userAdditionalInfo[name]) {
      this.sendNotification({title, text, color: 'dark', time: 10000, icon})
      store.dispatch('ADDITIONAL_USER_INFO', { [name]: true })
    }
  }
}
